export const CLASSIFICATION = 'classification'
export const RANKINGS = 'rankings'


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StandingsBody/constants.js